module.exports = __webpack_public_path__ + "static/media/bwg-foods.70e98f38.png";